export const MAIN_CLASS_NAME = 'elma365-tool-table';
export const TABLE_ROW_CLASS_NAME = `${MAIN_CLASS_NAME}__table-row`;
export const TABLE_ROW_DISABLED_CLASS_NAME = `${TABLE_ROW_CLASS_NAME}_disabled`;
export const PAGINATION_ROW_CLASS_NAME = `${MAIN_CLASS_NAME}__pagination-row`;
export const CELL_CLASS_NAME = `${TABLE_ROW_CLASS_NAME}__cell`;
export const COMPONENT_CELL_CLASS_NAME = `${CELL_CLASS_NAME}_component`;
